import { faAngleLeft } from "@fortawesome/pro-regular-svg-icons";

import Icon from "common/components/Icon";
import LinkButton from "common/components/LinkButton";

import DrawerLayout from "client/common/components/stackables/DrawerLayout";
import { useBreakpoints } from "client/common/hooks";
import { useCurrentDrawer } from "client/common/hooks/stackables";

import styles from "../styles/ReminderDrawerLayout.module.less";

type ReminderDrawerLayoutProps = {
  description?: React.ReactNode;
  /** Shows a back button at the top of the drawer content when provided */
  onBack?: (() => void) | null;
  /** Buttons for the sticky footer, which is hidden when not provided */
  actions?: React.ReactNode;
  children: React.ReactNode;
};

/** Shared header, body, and footer layout for the reminder create and edit drawers */
const ReminderDrawerLayout = ({
  description,
  onBack,
  actions,
  children,
}: ReminderDrawerLayoutProps) => {
  const { close } = useCurrentDrawer();
  const { isPhoneAndSmaller } = useBreakpoints();

  return (
    <DrawerLayout>
      <DrawerLayout.Header title="Dosage Reminders" description={description} onClose={close} />
      <DrawerLayout.Content>
        <div>
          {onBack && (
            <LinkButton className={styles.back} onClick={onBack}>
              <Icon icon={faAngleLeft} />
              Select different medication
            </LinkButton>
          )}
          <div className={styles.body}>{children}</div>
        </div>
      </DrawerLayout.Content>
      {actions && (
        <DrawerLayout.Actions isSticky={isPhoneAndSmaller}>{actions}</DrawerLayout.Actions>
      )}
    </DrawerLayout>
  );
};

export default ReminderDrawerLayout;
